import { useEffect, useState } from 'react';

export function useWidth() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const calcTiles = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', calcTiles);
    return () => window.removeEventListener('resize', calcTiles);
  }, []);

  return width;
}
